// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3EWXj","resendInfoText":"OnGoingPaymentBox_resendInfoText__1wcll"};